import * as React from "react";
import blurDataUrl from "@utils/shimmer";
import { NextPageWithLayout } from "@pages/_app";
import HomeLayout from "@layouts/home";
import fetch from "isomorphic-fetch";
import Icon from "@components/icon";
import Link from "next/link";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "next/router";
import {
  GetMyVendorProfile,
  GetVendorServiceByID,
} from "@graphql/queries/vendor.query";
import {
  GetMyVendorProfileQuery,
  GetMyVendorProfileQueryVariables,
  GetVendorServiceByIdQuery,
  GetVendorServiceByIdQueryVariables,
  PinVendorServiceMutation,
  PinVendorServiceMutationVariables,
  RefreshQuery,
  UnPinVendorServiceMutation,
  UnPinVendorServiceMutationVariables,
} from "@graphql/types";
import {
  deleteAccessCookie,
  deleteRefreshCookie,
  getAccessCookie,
  getRefreshCookie,
  setAccessCookie,
  setRefreshCookie,
} from "@utils/storage";
import {
  cacheExchange,
  dedupExchange,
  fetchExchange,
  makeOperation,
  Operation,
  OperationResult,
  ssrExchange,
  useMutation,
  useQuery,
} from "urql";
import { GetServerSideProps } from "next";
import { AuthState } from "@utils/auth";
import jwt_decode, { JwtPayload } from "jwt-decode";
import { withUrqlClient, initUrqlClient } from "next-urql";
import { authExchange } from "@urql/exchange-auth";
import {
  PinVendorService,
  UnpinVendorService,
} from "@graphql/mutations/vendor.mutation";
import { withTimeout } from "@utils/ssr-query";
import toast from "react-hot-toast";
import useStore from "src/store";
import { Spinner } from "@components/spinner";
import RadixDialog from "@components/dialog";
import SetBooking from "src/modals/set-booking";
import Head from "next/head";

type Props = {
  profile: string;
  vendorProfileData: OperationResult<
    GetMyVendorProfileQuery,
    GetMyVendorProfileQueryVariables
  > | null;
  vendorServiceData: OperationResult<
    GetVendorServiceByIdQuery,
    GetVendorServiceByIdQueryVariables
  > | null;
};

const SingleProfile: NextPageWithLayout<Props> = (props) => {
  const [show, setShow] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const accessToken = useStore((state) => state.accessToken);

  React.useEffect(() => {
    setShow(true);
  }, []);

  const router = useRouter();

  //   const [serviceResult] = useQuery<
  //     GetVendorServiceByIdQuery,
  //     GetVendorServiceByIdQueryVariables
  //   >({
  //     query: GetVendorServiceByID,
  //     pause: !props.profile,
  //     variables: { vendorServiceId: props.profile },
  //   });

  // const [vendorProfileResult] = useQuery<
  //   GetMyVendorProfileQuery,
  //   GetMyVendorProfileQueryVariables
  // >({
  //   query: GetMyVendorProfile,
  //   pause: !props.profile || !accessToken,
  // });

  const [pinState, setPinState] = React.useState(
    props.vendorServiceData?.data?.getVendorServiceByID.pinned
  );

  const [, pinFn] = useMutation<
    PinVendorServiceMutation,
    PinVendorServiceMutationVariables
  >(PinVendorService);

  const [, unPinFn] = useMutation<
    UnPinVendorServiceMutation,
    UnPinVendorServiceMutationVariables
  >(UnpinVendorService);

  return (
    <>
      <Head>
        <title>Inawo Vendors | Profile</title>
        <meta name="title" content="Inawo Vendors | Profile" />
        <meta name="description" content="Vendors Profile on Inawo Vendors" />
      </Head>

      <div className="w-full">
        {props.vendorServiceData?.error?.message ? (
          <>An error occured</>
        ) : (
          !!props.vendorServiceData?.data?.getVendorServiceByID && (
            <>
              <div className="w-full pt-8 flex justify-start items-center gap-2 text-inawo-black">
                <Link href={"/"}>
                  <div className="p-1.5 bg-transparent transition hover:bg-gray-50 rounded-md">
                    <Icon iconName="arrowLeft" />
                  </div>
                </Link>
                <p className="uppercase tracking-widest font-light font-sfpro text-base xs:text-lg">
                  Service Profile
                </p>
              </div>
              <div className="max-w-full mx-auto w-fit flex flex-col justify-center relative items-center gap-2 my-5">
                <div className="max-w-[250px] md:max-w-lg flex justify-center relative mx-auto items-center">
                  <h2 className="font-sfpro text-center text-inawo-green w-[12rem] md:w-80 text-xl md:text-4xl font-medium">
                    {props.vendorServiceData?.data?.getVendorServiceByID
                      .service_name ?? ""}
                  </h2>
                  <div className="w-8 md:w-12 absolute top-0 -right-8 md:-right-16">
                    <CircularProgressbar
                      value={
                        props.vendorServiceData?.data.getVendorServiceByID
                          .rating
                          ? props.vendorServiceData?.data.getVendorServiceByID
                              .rating * 20
                          : 0
                      }
                      text={
                        props.vendorServiceData?.data.getVendorServiceByID
                          .rating
                          ? `${props.vendorServiceData?.data.getVendorServiceByID.rating}`
                          : "0"
                      }
                      styles={buildStyles({
                        textColor: "#273F3B",
                        pathColor: "#CBB915",
                        trailColor: "#DBDFF1",
                        textSize: "36px",
                      })}
                    />{" "}
                  </div>
                </div>
                <p className="uppercase text-[10px] md:text-sm max-w-[250px] tracking-widest font-light text-center text-inawo-green">
                  {props.vendorServiceData?.data?.getVendorServiceByID.category
                    ?.Name ?? ""}
                </p>
                <p className="font-light text-center max-w-sm md:max-w-md text-inawo-green text-sm md:text-lg">
                  {props.vendorServiceData?.data?.getVendorServiceByID
                    ?.description ?? ""}
                </p>
                <div className="flex gap-2 justify-center items-center">
                  <p className="text-[10px] md:text-sm text-inawo-green font-medium">
                    Price starts from:
                  </p>{" "}
                  <p className="text-inawo-green text-sm md:text-lg">
                    N
                    {props.vendorServiceData?.data?.getVendorServiceByID.price.amount?.toLocaleString()}
                  </p>
                </div>
              </div>
              <div className="flex justify-center items-center gap-4">
                {pinState ? (
                  <div
                    onClick={() => {
                      if (!!accessToken) {
                        setPinState(false);
                        toast.success(
                          <p className="toast">You unpinned this service</p>
                        );
                        unPinFn({
                          vendorServiceId:
                            props.vendorServiceData?.data?.getVendorServiceByID
                              .id,
                        }).catch(() => {
                          setPinState(true);
                          toast.error(
                            <p className="toast">
                              Couldn&apos;t unpin{" "}
                              <span className="font-bold">
                                {
                                  props.vendorServiceData?.data
                                    ?.getVendorServiceByID.service_name
                                }
                              </span>{" "}
                              service
                            </p>
                          );
                        });
                      } else {
                        router.push("/login");
                        toast.error(
                          <p className="toast">
                            You need to be logged in to show interest
                          </p>
                        );
                      }
                    }}
                    className="transition hover:bg-gray-200 cursor-pointer rounded-md grid place-items-center"
                  >
                    <Icon iconName="pinGreenActive" />
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      if (!!accessToken) {
                        setPinState(true);
                        toast.success(
                          <p className="toast">You pinned this service</p>
                        );
                        pinFn({
                          vendorServiceId:
                            props.vendorServiceData?.data?.getVendorServiceByID
                              .id,
                        }).catch(() => {
                          setPinState(false);
                          toast.error(
                            <p className="toast">
                              Couldn&apos;t pin{" "}
                              <span className="font-bold">
                                {
                                  props.vendorServiceData?.data
                                    ?.getVendorServiceByID.service_name
                                }
                              </span>{" "}
                              service
                            </p>
                          );
                        });
                      } else {
                        router.push("/login");
                        toast.error(
                          <p className="toast">
                            You need to be logged in to show interest
                          </p>
                        );
                      }
                    }}
                    className="transition hover:bg-gray-200 active:bg-gray-300 cursor-pointer rounded-md grid place-items-center"
                  >
                    <Icon iconName="pinGreen" />
                  </div>
                )}
                <div>
                  <RadixDialog
                    open={openModal}
                    onOpenChange={setOpenModal}
                    trigger={
                      <div
                        onClick={() => setOpenModal(true)}
                        className="w-full text-white bg-inawo-green active:bg-inawo-green px-6 py-2.5 shadow flex justify-center items-center rounded-[0.75rem] transition hover:bg-inawo-green/95 cursor-pointer disabled:cursor-not-allowed disabled:bg-inawo-grey-200"
                      >
                        Book
                      </div>
                    }
                  >
                    <SetBooking
                      setOpenModal={setOpenModal}
                      serviceName={
                        props.vendorServiceData?.data.getVendorServiceByID
                          .service_name
                      }
                      accessToken={accessToken}
                      id={props.vendorServiceData?.data.getVendorServiceByID.id}
                    />
                  </RadixDialog>
                </div>
                <a
                  target={"_blank"}
                  rel="noreferrer noopener"
                  href={`https://wa.me/${props.vendorServiceData?.data?.getVendorServiceByID.phone_number?.replace(
                    /[^0-9]/g,
                    ""
                  )}`}
                  className="p-2.5 bg-transparent transition hover:bg-gray-200 active:bg-gray-300 rounded-md cursor-pointer"
                >
                  <Icon iconName="whatsapp" />
                </a>
              </div>
              {props.vendorServiceData?.data.getVendorServiceByID.vendors_id ===
                props?.vendorProfileData?.data?.getMyVendorProfile.id && (
                <div className="w-full flex justify-center items-center my-4">
                  <Link
                    href={`/become-a-vendor/add-a-service?serviceId=${props.vendorServiceData?.data.getVendorServiceByID.id}`}
                  >
                    <button className="text-inawo-green text-sm md:text-base px-4 py-2 rounded-md transition hover:bg-gray-200 active:bg-gray-300 mx-auto">
                      + Update your showcase
                    </button>
                  </Link>
                </div>
              )}
              <div className="my-10 ">
                {show ? (
                  <Swiper
                    spaceBetween={8}
                    className="profile-swiper"
                    slidesPerView={2.8}
                    // modules={[Scrollbar, A11y]}
                    // scrollbar={{ draggable: true }}
                    centerInsufficientSlides
                    grabCursor
                    breakpoints={{
                      // when window width is >= 320px
                      320: {
                        slidesPerView: 2.8,
                        spaceBetween: 8,
                      },
                      // when window width is >= 480px
                      480: {
                        slidesPerView: 3.4,
                        spaceBetween: 10,
                      },
                      // when window width is >= 640px
                      640: {
                        slidesPerView: 3.8,
                        spaceBetween: 15,
                      },
                      789: {
                        slidesPerView: 4.2,
                        spaceBetween: 20,
                      },
                      1280: {
                        slidesPerView: 4.2,
                        spaceBetween: 20,
                      },
                      1440: {
                        slidesPerView: 6.0,
                        spaceBetween: 25,
                      },
                      1840: {
                        slidesPerView: 6.9,
                        spaceBetween: 25,
                      },
                      2200: {
                        slidesPerView: 7.8,
                        spaceBetween: 25,
                      },
                    }}
                  >
                    {props.vendorServiceData?.data?.getVendorServiceByID.showcase?.map(
                      (item) => (
                        <SwiperSlide key={uuidv4()}>
                          <RadixDialog
                            closeButtonTop
                            trigger={
                              <div className="flex bg-inawo-green rounded-[15px] overflow-hidden flex-col justify-start items-start gap-2 relative h-32 sm:h-48 md:h-64 my-2 md:my-4">
                                {item?.media ? (
                                  <Image
                                    src={item?.media}
                                    placeholder="blur"
                                    objectFit="cover"
                                    blurDataURL={blurDataUrl(400, 400)}
                                    objectPosition="center"
                                    layout="fill"
                                    quality={75}
                                    sizes="30vw"
                                    alt={`service`}
                                    priority
                                  />
                                ) : (
                                  <Icon iconName="sample" />
                                )}
                              </div>
                            }
                          >
                            <div className="w-[90%] h-[90%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 fixed p-4 md:p-8">
                              {item?.media ? (
                                <Image
                                  src={item?.media}
                                  placeholder="blur"
                                  objectFit="contain"
                                  blurDataURL={blurDataUrl(400, 400)}
                                  objectPosition="center"
                                  layout="fill"
                                  quality={90}
                                  sizes="90vw"
                                  alt={`service modal`}
                                  priority
                                />
                              ) : (
                                <Icon iconName="sample" />
                              )}
                            </div>
                          </RadixDialog>
                        </SwiperSlide>
                      )
                    )}
                  </Swiper>
                ) : (
                  <div className="h-36 sm:h-52 md:h-72" />
                )}
              </div>
            </>
          )
        )}
      </div>
    </>
  );
};

SingleProfile.getLayout = function getLayout(page: React.ReactElement) {
  return <HomeLayout>{page}</HomeLayout>;
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { req, res, params } = ctx;
  const accessToken = getAccessCookie({ req, res });
  const ssrCache = ssrExchange({ isClient: false });
  const client = initUrqlClient(
    {
      url: process.env.NEXT_PUBLIC_API_URL!,
      requestPolicy: "cache-and-network",
      fetchOptions: {
        headers: {
          "x-user-token": accessToken ? `${accessToken}` : "",
        },
      },
      exchanges: [
        dedupExchange,
        cacheExchange,
        authExchange({
          addAuthToOperation: ({
            authState,
            operation,
          }: {
            authState: AuthState;
            operation: Operation;
          }) => {
            // the token isn't in the auth state, return the operation without changes
            if (!authState || !authState.accessToken) {
              return operation;
            }

            // fetchOptions can be a function (See Client API) but you can simplify this based on usage
            const fetchOptions =
              typeof operation.context.fetchOptions === "function"
                ? operation.context.fetchOptions()
                : operation.context.fetchOptions || {};

            return makeOperation(operation.kind, operation, {
              ...operation.context,
              requestPolicy: "network-only",
              fetchOptions: {
                ...fetchOptions,
                headers: {
                  ...fetchOptions.headers,
                  "x-user-token": authState.accessToken
                    ? `${authState.accessToken}`
                    : "",
                },
              },
            });
          },
          willAuthError: ({ authState }) => {
            if (!authState) return true;
            // e.g. check for expiration, existence of auth etc
            const accessTokenDecoded = jwt_decode<JwtPayload>(
              authState.accessToken as string
            );
            const refreshTokenDecoded = jwt_decode<JwtPayload>(
              authState.refreshToken as string
            );

            // if access token will almost expire
            if (
              !!accessTokenDecoded?.exp &&
              Date.now() >= accessTokenDecoded?.exp * 1000
            ) {
              return true;
            }

            // if refresh token will almost expire
            if (
              !!refreshTokenDecoded?.exp &&
              Date.now() >= refreshTokenDecoded?.exp * 1000
            ) {
              return true;
            }

            return false;
          },
          didAuthError: ({ error }) => {
            // check if the error was an auth error (this can be implemented in various ways, e.g. 401 or a special error code)
            return error.graphQLErrors.some((e) =>
              e.message.includes("unauthenticated")
            );
          },
          getAuth: async ({ authState }) => {
            // for initial launch, fetch the auth state from storage (local storage, async storage etc)
            if (!authState) {
              const accessToken = getAccessCookie({ req, res }) as string;
              const refreshToken = getRefreshCookie({ req, res }) as string;

              if (accessToken && refreshToken) {
                return { accessToken, refreshToken };
              }
              return null;
            }

            /**
             * the following code gets executed when an auth error has occurred
             * we should refresh the token if possible and return a new auth state
             * If refresh fails, we should log out
             **/

            const resultInitial = await fetch(
              process.env.NEXT_PUBLIC_API_URL!,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  query: `
										query Refresh($refresh_token: String!) {
								refresh(refresh_token: $refresh_token) {
									refresh_token
									access_token
									access_expiry
								}
							}
					`,
                  variables: {
                    refresh_token: authState.refreshToken,
                  },
                }),
              }
            );

            const result: { data: RefreshQuery } = await resultInitial.json();

            if (result.data?.refresh) {
              // save the new tokens in storage for next restart
              setRefreshCookie(result.data.refresh.refresh_token, {
                req,
                res,
              });
              setAccessCookie(result.data.refresh.access_token, { req, res });
              return {
                accessToken: result.data.refresh.access_token,
                refreshToken: result.data.refresh.refresh_token,
              };
            }

            // otherwise, if refresh fails, log clear storage and log out
            console.log("Vendors RefreshQuery Profile page Error :>> ", result);
            deleteAccessCookie({ req, res });
            deleteRefreshCookie({ req, res });

            return null;
          },
        }),
        ssrCache,
        fetchExchange,
      ],
    },
    false
  );

  let vendorServiceData: OperationResult<
    GetVendorServiceByIdQuery,
    GetVendorServiceByIdQueryVariables
  > | null = null;

  try {
    if (client && params?.profile) {
      vendorServiceData = await withTimeout(
        client
          .query<GetVendorServiceByIdQuery, GetVendorServiceByIdQueryVariables>(
            GetVendorServiceByID,
            { vendorServiceId: params.profile }
          )
          .toPromise(),
        "GetVendorServiceByID (profile/[profile])"
      );
    }
  } catch (error) {
    console.error("[SSR] GetVendorServiceByID (profile/[profile]) failed:", {
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
    });
  }

  let vendorProfileData: OperationResult<
    GetMyVendorProfileQuery,
    GetMyVendorProfileQueryVariables
  > | null = null;

  try {
    if (client) {
      vendorProfileData = await withTimeout(
        client
          .query<GetMyVendorProfileQuery, GetMyVendorProfileQueryVariables>(
            GetMyVendorProfile
          )
          .toPromise(),
        "GetMyVendorProfile (profile/[profile])"
      );
    }
  } catch (error) {
    console.error("[SSR] GetMyVendorProfile (profile/[profile]) failed:", {
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
    });
  }

  return {
    props: {
      profile: params?.profile,
      urqlState: JSON.parse(
        JSON.stringify(ssrCache.extractData(), (key, value) => {
          if (value === undefined) return null;
          if (key === "path" && Array.isArray(value)) {
            return value.map((item) => (item === undefined ? null : item));
          }
          return value;
        })
      ),
      vendorServiceData: JSON.parse(JSON.stringify(vendorServiceData)),
      vendorProfileData: JSON.parse(JSON.stringify(vendorProfileData)),
    },
  };
};

export default withUrqlClient(
  (_ssr) => ({
    url: process.env.NEXT_PUBLIC_API_URL!,
    requestPolicy: "cache-and-network",
    fetchOptions: () => {
      return {
        headers: {
          "x-user-token": getAccessCookie() ? `${getAccessCookie()}` : "",
        },
      };
    },
  }),
  { ssr: false }
)(SingleProfile);
